import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { SchemaNode } from '../../models'

export class SchemaIntersectionNode extends SchemaNode {
  @fromSpecific()
  @reactive('shallow')
  types: SchemaNode[] = []
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Intersection': SchemaIntersectionNode
  }
}
